import { api } from './api';

export interface SendUserFeedbackFile {
  fileName: string;
  mimeType: string;
  fileSizeBytes: number;
  fileData: string;
}

export interface SendUserFeedbackInput {
  subject: string;
  description: string;
  platform: string;
  deviceModel: string | null;
  files?: SendUserFeedbackFile[];
}

export function sendUserFeedback(
  input: SendUserFeedbackInput,
): Promise<{ feedbackId: number }> {
  return api.post<{ feedbackId: number }>(
    '/user-feedback',
    {
      subject: input.subject,
      description: input.description,
      platform: input.platform,
      deviceModel: input.deviceModel,
      files: input.files ?? [],
    },
    { timeout: 300000 },
  );
}
